import qs from 'qs';
import { network } from 'services/network';

export const getCard = (params) => {
    let idParam = params.id;
    let isVirtualParam = params.isVirtual;

    if (params.id !== 'newCard') {
        const _id = params.id.split('-');
        if (_id[1]) {
            idParam = _id[0];
            isVirtualParam = true;
        }
    }

    const queryString = qs.stringify(
        { id: idParam, isVirtual: isVirtualParam, versionId: params.versionId },
        { addQueryPrefix: true, skipNulls: true },
    );

    const url = `api/bo/getCard${queryString}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
